<template>
  <section class="well should-you-call-initial-conclusion">
    <header class="page-header">
      <h1 v-if="streetToCall !== 'river'">Initial analysis</h1>
      <h1 v-if="streetToCall === 'river'">Analysis</h1>
    </header>
    <section class="alert" v-bind:class="{ 'alert-success': isCallProfitableBasedOnPotOdds, 'alert-danger': !isCallProfitableBasedOnPotOdds }">
      <p v-if="streetToCall !== 'river'">If we don't factor in the possibility of betting on future streets, calling the {{ streetToCall }} bet with {{ potOdds }} pot odds <em>will <span v-if="!isCallProfitableBasedOnPotOdds">not</span></em> be profitable <span v-if="isCallProfitableBasedOnPotOdds">✅</span><span v-else>❌</span></p>
      <p v-if="streetToCall === 'river'">Calling the river bet with {{ potOdds }} pot odds <em>will <span v-if="!isCallProfitableBasedOnPotOdds">not</span></em> be profitable <span v-if="isCallProfitableBasedOnPotOdds">✅</span><span v-else>❌</span></p>
    </section>
    <table class="table">
      <thead>
        <tr>
          <th>Equity</th>
          <th>Pot odds</th>
          <th>Break even percentage for {{ potOdds }} pot odds</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ equity }}%</td>
          <td>{{ potOdds}}</td>
          <td>{{ breakevenPercentageViaPotOdds }}%</td>
        </tr>
      </tbody>
    </table>
    <p>Reasoning:</p>
    <ul>
      <li>
        When you have {{ potOdds }} pot odds, <span v-if="streetToCall !== 'river'">without factoring in the possibility of betting on future streets, </span>for a call to be profitable, you need more than {{ breakevenPercentageViaPotOdds}}% equity.
        <toggle-help-button
          v-bind:helpAreaVisible="helpAreaVisible.reasoning[0]"
          v-on:toggleHelp="toggleHelp('reasoning', 0)"
        />
        <reasoning-help-section-1 v-if="helpAreaVisible.reasoning[0]"/>
      </li>
      <li>
        According to your assumptions, you have {{ equity }}% equity, which is <span v-if="isCallProfitableBasedOnPotOdds">more</span><span v-else>less</span> than the {{ breakevenPercentageViaPotOdds }}% you need.
        <toggle-help-button
          v-bind:helpAreaVisible="helpAreaVisible.reasoning[1]"
          v-on:toggleHelp="toggleHelp('reasoning', 1)"
        />
        <div v-if="helpAreaVisible.reasoning[1]" class="well">
          This is your equity versus your opponents {{ streetToCall }} betting range. It is based on your assumptions because you've assumed that your opponent has whatever {{ streetToCall }} betting range. If that range were different, the equity would be different, and the conclusion you come to about whether or not to call may end up being different.
        </div>
      </li>
      <li>Therefore, according to this initial analysis, your call will <span v-if="!isCallProfitableBasedOnPotOdds">not</span> be profitable.</li>
    </ul>
  </section>
</template>

<script>
import ToggleHelpButton from '@/components/guided-analyses/help/toggle-help-button';
import ReasoningHelpSectionOne from '@/components/guided-analyses/should-you-call/help/reasoning-1';

export default {
  name: 'should-you-call-initial-conclusion',
  components: {
    'toggle-help-button': ToggleHelpButton,
    'reasoning-help-section-1': ReasoningHelpSectionOne,
  },
  props: ['potOdds', 'equity', 'streetToCall', 'breakevenPercentageViaPotOdds'],
  data: function () {
    return {
      helpAreaVisible: {
        reasoning: [false, false],
      },
    };
  },
  computed: {
    isCallProfitableBasedOnPotOdds: function () {
      return this.equity > this.breakevenPercentageViaPotOdds;
    },
  },
  methods: {
    toggleHelp: function (type, index) {
      if (type === 'reasoning') {
        this.helpAreaVisible.reasoning[index] = !this.helpAreaVisible.reasoning[index];
      }

      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import 'src/assets/help-section';

  .should-you-call-initial-conclusion {
    font-size: 18px;

    pre {
      font-size: 16px;
    }

    h1, li, p, table {
      max-width: 900px;
    }

    .well {
      margin-top: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/guided-analyses/should-you-call/conclusions/initial-conclusion.vue